import { render, staticRenderFns } from "./lista_departamentos_prolipa.vue?vue&type=template&id=23a40090&scoped=true"
import script from "./lista_departamentos_prolipa.vue?vue&type=script&lang=js"
export * from "./lista_departamentos_prolipa.vue?vue&type=script&lang=js"
import style0 from "./lista_departamentos_prolipa.vue?vue&type=style&index=0&id=23a40090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a40090",
  null
  
)

export default component.exports